import {HttpAxiosRequest} from "../../../http/httpAxiosBase";
import {DashboardViewDTO, schemaDashboard} from "../types/dashboard";


export const getEndpoint = (url = '') => `dashboard/${url}`

export const HttpDashboard = {
  get: (codPais: number, codTipoMensaje: number | null,): Promise<DashboardViewDTO> => {
    return HttpAxiosRequest.get(getEndpoint(`${codPais}/${codTipoMensaje}`))
      .then(response => {
        const parsed = schemaDashboard.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        // return response.data

        return parsed.data

      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },
}